"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.html = void 0;
const html = require('./html.ejs.js').default;
exports.html = html;
